import { Fetch } from "../HttpClient/FetchImplementation/Fetch";
import { getCandyHub } from "../../Engine/src/Forms/Sentry/InitializeSentry";

export interface IDriveContentsCopyResult {
    Name: string;
}

export interface IDriveApiClientExtension {
    copyContents(name: string, copyName: string): Promise<IDriveContentsCopyResult>;
}

export class DriveApiClientExtension implements IDriveApiClientExtension {
    private readonly fetchImpl: Fetch;
    private readonly baseUrl: string;

    public constructor(fetchImpl: Fetch, baseUrl: string) {
        this.fetchImpl = fetchImpl;
        this.baseUrl = baseUrl;
    }

    public async copyContents(name: string, copyName: string): Promise<IDriveContentsCopyResult> {
        const response = await this.fetchImpl(`${this.baseUrl}/v1/contents/copy`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                name: decodeURI(name),
                copyName: decodeURI(copyName),
                expiryTimeChange: {
                    makePermanent: false,
                    newDaysToLive: 1,
                },
            }),
        });

        if (response.status === 403) {
            getCandyHub().captureException(new Error(`Drive contents copy forbidden: ${name}`));
            return {
                Name: name,
            };
        }

        if (response.status === 409) {
            return {
                Name: copyName,
            };
        }

        if (response.status >= 400 && response.status <= 500) {
            return {
                Name: name,
            };
        }

        const result = await response.json();

        return result as IDriveContentsCopyResult;
    }
}
